import {Auth} from "types/auth"
import {fieldsService} from "services"
import CircularSpin from "components/CircularSpin"
import {useQuery} from "@tanstack/react-query"
import {Settings} from "types/settings"
import CustomFieldContent from "./CustomFieldContent"

type Props = {
    student: Auth.DepartmentStudent
    module: Settings.CustomFieldModule
    readOnly?: boolean
}

const EditableStudentCustomField = ({student, module, readOnly = false}: Props) => {
    const {data: customFields, isLoading} = useQuery(["module-shortcut-custom-fields", module], () =>
        fieldsService.getCustomFields({
            filter: {modules: [module], isShortcut: true},
            range: {page: 1, pageSize: 1000}
        })
    )
    const {data: customFieldsForProfile, isFetching: isLoadingCustomFieldsForProfile} = useQuery(
        ["student-module-custom-fields-for-profile", student.userId, student.profileId, module],
        () =>
            fieldsService.getCustomFieldsForProfile({
                filter: {userIds: [student.userId], profileIds: [student.profileId], modules: [module]}
            })
    )

    if (isLoading || isLoadingCustomFieldsForProfile) {
        return <CircularSpin size="small" />
    }

    return (
        <>
            {customFields.data.map((customField) => (
                <CustomFieldContent
                    key={customField.customFieldId}
                    field={customField}
                    defaultValue={
                        customFieldsForProfile.find((item) => item.customFieldId === customField.customFieldId)?.value
                    }
                    student={student}
                    readOnly={readOnly}
                />
            ))}
        </>
    )
}

export default EditableStudentCustomField
